import u from "./index443.mjs";
import { handleBreakpoints as f } from "./index447.mjs";
import { getPath as l } from "./index444.mjs";
import y from "./index448.mjs";
import h from "./index452.mjs";
const v = {
  m: "margin",
  p: "padding"
}, E = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, c = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, N = h((n) => {
  if (n.length > 2)
    if (c[n])
      n = c[n];
    else
      return [n];
  const [e, o] = n.split(""), r = v[e], a = E[o] || "";
  return Array.isArray(a) ? a.map((i) => r + i) : [r + a];
}), s = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], d = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], I = [...s, ...d];
function B(n, e, o, r) {
  var a;
  const i = (a = l(n, e, !1)) != null ? a : o;
  return typeof i == "number" ? (t) => typeof t == "string" ? t : (process.env.NODE_ENV !== "production" && typeof t != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${t}.`), i * t) : Array.isArray(i) ? (t) => typeof t == "string" ? t : (process.env.NODE_ENV !== "production" && (Number.isInteger(t) ? t > i.length - 1 && console.error([`MUI: The value provided (${t}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${t} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${e}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${e}\` as a number.`].join(`
`))), i[t]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${e}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function T(n) {
  return B(n, "spacing", 8, "spacing");
}
function $(n, e) {
  if (typeof e == "string" || e == null)
    return e;
  const o = Math.abs(e), r = n(o);
  return e >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function P(n, e) {
  return (o) => n.reduce((r, a) => (r[a] = $(e, o), r), {});
}
function x(n, e, o, r) {
  if (e.indexOf(o) === -1)
    return null;
  const a = N(o), i = P(a, r), t = n[o];
  return f(n, t, i);
}
function g(n, e) {
  const o = T(n.theme);
  return Object.keys(n).map((r) => x(n, e, r, o)).reduce(y, {});
}
function p(n) {
  return g(n, s);
}
p.propTypes = process.env.NODE_ENV !== "production" ? s.reduce((n, e) => (n[e] = u, n), {}) : {};
p.filterProps = s;
function m(n) {
  return g(n, d);
}
m.propTypes = process.env.NODE_ENV !== "production" ? d.reduce((n, e) => (n[e] = u, n), {}) : {};
m.filterProps = d;
process.env.NODE_ENV !== "production" && I.reduce((n, e) => (n[e] = u, n), {});
export {
  T as createUnarySpacing,
  B as createUnaryUnit,
  P as getStyleFromPropValue,
  $ as getValue,
  p as margin,
  s as marginKeys,
  m as padding,
  d as paddingKeys
};
